export interface IAstNodeType {
  type: string;
  isArray?: boolean;
}
export const TypeGenerator = {
  Integer(): IAstNodeType {
    return { type: 'Integer' };
  },
  IntegerArray(options?: {
    ownerFqn?: string,
    values?: string[],
    isLiteralArray?: boolean
  }): IAstNodeType {
    return { type: 'Integer', ...options, isArray: true };
  },
  Number(): IAstNodeType {
    return { type: 'Number' };
  },
  NumberArray(options?: {
    ownerFqn?: string,
    values?: string[],
    isLiteralArray?: boolean
  }): IAstNodeType {
    return { type: 'Number', ...options, isArray: true };
  },
  Id(options?: { ownerFqn?: string }): IAstNodeType {
    return { type: 'Id', ...options };
  },
  IdArray(options?: { path?: string, ownerFqn?: string }): IAstNodeType {
    return { type: 'Id', ...options, isArray: true };
  },
  String(options?: { ownerFqn?: string }): IAstNodeType {
    return { type: 'String', ...options };
  },
  StringArray(options?: {
    ownerFqn?: string,
    values?: string[],
    isLiteralArray?: boolean
  }): IAstNodeType {
    return { type: 'String', ...options, isArray: true };
  },
  Email(): IAstNodeType {
    return { type: 'Email' };
  },
  EmailArray(): IAstNodeType {
    return { type: 'Email', isArray: true };
  },
  Url(): IAstNodeType {
    return { type: 'Url' };
  },
  UrlArray(): IAstNodeType {
    return { type: 'Url', isArray: true };
  },
  PhoneNr(): IAstNodeType {
    return { type: 'PhoneNr' };
  },
  PhoneNrArray(): IAstNodeType {
    return { type: 'PhoneNr', isArray: true };
  },
  Boolean(): IAstNodeType {
    return { type: 'Boolean' };
  },
  BooleanArray(): IAstNodeType {
    return { type: 'Boolean', isArray: true };
  },
  Null(): IAstNodeType {
    return { type: 'Null' };
  },
  NullArray(): IAstNodeType {
    return { type: 'Null', isArray: true };
  },
  Enum(options = {}): IAstNodeType {
    return { type: 'Enum', ...options };
  },
  EnumArray(options = {}): IAstNodeType {
    return { type: 'Enum', ...options, isArray: true };
  },
  DateTime(): IAstNodeType {
    return { type: 'DateTime' };
  },
  DateTimeArray(): IAstNodeType {
    return { type: 'DateTime', isArray: true };
  },
  Date(): IAstNodeType {
    return { type: 'Date' };
  },
  DateArray(): IAstNodeType {
    return { type: 'Date', isArray: true };
  },
  Time(): IAstNodeType {
    return { type: 'Time' };
  },
  TimeArray(): IAstNodeType {
    return { type: 'Time', isArray: true };
  },
  ArrayOf(v: string, options = {}): IAstNodeType {
    return { ...options, type: v, isArray: true };
  },
  create(type: string, options: any = {}): IAstNodeType {
    const isArray = options.isArray || false;
    return { ...options, type, isArray };
  }
};

export default TypeGenerator;



/**
 * 判断节点是否为 Boolean 或 BooleanArray 类型
 * @param astNode IAstNodeType
 * @param isArray 可选
 */
export function isBoolean(astNode: IAstNodeType, isArray?: boolean) {
  if (astNode.type === 'Boolean') {
    return isArray === undefined || Boolean(astNode.isArray) === isArray;
  }
  return false;
}


/**
 * 判断节点是否为 Integer 或 IntegerArray 类型
 * @param astNode IAstNodeType
 * @param isArray 可选
 */
export function isInteger(astNode: IAstNodeType, isArray?: boolean) {
  if (astNode.type === 'Integer') {
    return isArray === undefined || Boolean(astNode.isArray) === isArray;
  }
  return false;
}


/**
 * 判断节点是否为 Number 或 NumberArray 类型
 * @param astNode IAstNodeType
 * @param isArray 可选
 */
export function isNumber(astNode: IAstNodeType, isArray?: boolean) {
  if (astNode.type === 'Number') {
    return isArray === undefined || Boolean(astNode.isArray) === isArray;
  }
  return false;
}


/**
 * 判断节点是否为 数字 或 数字数组 类型
 * @param astNode IAstNodeType
 * @param isArray 可选
 */
export function isDigit(astNode: IAstNodeType, isArray?: boolean) {
  if (['Number', 'Integer'].includes(astNode.type)) {
    return isArray === undefined || Boolean(astNode.isArray) === isArray;
  }
  return false;
}

/**
 * 判断节点是否为 String 或 StringArray 类型
 * @param astNode IAstNodeType
 * @param isArray 可选
 */
export function isString(astNode: IAstNodeType, isArray?: boolean) {
  if (astNode.type === 'String') {
    return isArray === undefined || Boolean(astNode.isArray) === isArray;
  }
  return false;
}

/**
 * 判断节点是否为 类String 或 类StringArray 类型
 * @param astNode IAstNodeType
 * @param isArray 可选
 */
export function isStringLike(astNode: IAstNodeType, isArray?: boolean) {
  if (['String', 'Email', 'Url', 'PhoneNr'].includes(astNode.type)) {
    return isArray === undefined || Boolean(astNode.isArray) === isArray;
  }
  return false;
}


/**
 * 判断节点是否为 DateTime 或 DateTimeArray 类型
 * @param astNode IAstNodeType
 * @param isArray 可选
 */
export function isDateTime(astNode: IAstNodeType, isArray?: boolean) {
  if (astNode.type === 'DateTime') {
    return isArray === undefined || Boolean(astNode.isArray) === isArray;
  }
  return false;
}

/**
 * 判断节点是否为 类日期时间 或 类日期时间数组 类型
 * @param astNode IAstNodeType
 * @param isArray 可选
 */
export function isDateTimeLike(astNode: IAstNodeType, isArray?: boolean) {
  if (['DateTime', 'Date', 'Time'].includes(astNode.type)) {
    return isArray === undefined || Boolean(astNode.isArray) === isArray;
  }
  return false;
}

/**
 * 判断节点是否为 Null 或 NullArray 类型
 * @param astNode IAstNodeType
 * @param isArray 可选
 */
export function isNull(astNode: IAstNodeType, isArray?: boolean) {
  if (astNode.type === 'Null') {
    return isArray === undefined || Boolean(astNode.isArray) === isArray;
  }
  return false;
}

/**
 * 判断节点是否为 Id 或 IdArray 类型
 * @param astNode IAstNodeType
 * @param isArray 可选
 */
export function isId(astNode: IAstNodeType, isArray?: boolean) {
  if (astNode.type === 'Id') {
    return isArray === undefined || Boolean(astNode.isArray) === isArray;
  }
  return false;
}


/**
 * 判断节点是否为 Enum 或 EnumArray 类型
 * @param astNode IAstNodeType
 * @param isArray 可选
 */
export function isEnum(astNode: IAstNodeType, isArray?: boolean) {
  if (astNode.type === 'Enum') {
    return isArray === undefined || Boolean(astNode.isArray) === isArray;
  }
  return false;
}


// 数据类型是否`浅相等`
export function isShallowEquals(nodes: IAstNodeType[], isArray?: boolean) {
  const first = nodes[0];
  if (isDigit(first)) {
    return nodes.slice(1).every(node => isDigit(node, isArray));
  }
  if (isStringLike(first)) {
    return nodes.slice(1).every(node => isStringLike(node, isArray));
  }
  return nodes.slice(1).every(node => node.type === first.type);
}


export function isTypeShallowEquals(type1: string, type2: string) {
  if (['Integer', 'Number'].includes(type1) &&
    ['Integer', 'Number'].includes(type2)) {
    return true;
  }
  if (['String', 'PhoneNr', 'Email', 'Url'].includes(type1) &&
    ['String', 'PhoneNr', 'Email', 'Url'].includes(type2)) {
    return true;
  }

  return type1 === type2;
}
